import React, { useEffect, useState } from 'react';
import Navbar from '../util/Navbar';
import { Headline } from '../styles/Hero.styles.js';
import ZipQuote from './ZipQuote';
import styled from 'styled-components';
import { Box, Image, Text } from '@chakra-ui/core';

const ImageGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
`;

/**
 * The eyebrow and headline, together. The eyebrow takes over the headline's
 * drop from the top of the page; `Headline` sets its own margin at each
 * breakpoint, hence the doubled class to win over all of them.
 *
 * Not `styled(Headline)`: extending a styled component from a `.js` file in
 * TSX is TS2615 under this toolchain, and CRA fails the build on it.
 */
const Heading = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 25vh;

  && > h1 {
    margin-top: 0.75rem;
  }

  @media (max-width: 600px) {
    margin-top: 20vh;
  }
`;

const Eyebrow = styled.p`
  margin: 0;
  color: #253ec6;
  font-family: Poppins, sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

const Badge = styled.span`
  position: absolute;
  left: 4%;
  bottom: 14%;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 999px;
  background: #fff;
  color: #253ec6;
  font-size: 0.875rem;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(17, 24, 39, 0.14),
    0 2px 6px rgba(17, 24, 39, 0.08);
`;

export const openBooking = (
  options = undefined,
  ref: string | undefined = undefined
) => {
  let url = `https://booking.heyhomero.com`;

  if (options) {
    // @ts-ignore
    let { bedrooms, bathrooms, type } = options;
    url = url + `?be=${bedrooms}&ba=${bathrooms}&t=${type}`;
  }
  if (ref) {
    url += `${options ? '&' : '?'}ref=${ref}`;
  }
  let a = document.createElement('a');
  a.href = url;
  a.click();
};

export const openTasks = (
  options = undefined,
  ref: string | undefined = undefined
) => {
  let url = `https://booking.heyhomero.com/tasks`;
  if (options) {
    // @ts-ignore
    let { bedrooms, bathrooms, type } = options;
    url = url + `?be=${bedrooms}&ba=${bathrooms}&t=${type}`;
  }
  if (ref) {
    url += `${options ? '&' : '?'}ref=${ref}`;
  }
  let a = document.createElement('a');
  a.href = url;
  a.click();
};

export default function Hero(props) {
  const [width, setWidth] = useState(window.innerWidth);

  let _setWidth = () => setWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', _setWidth);
    return () => {
      window.removeEventListener('resize', _setWidth);
    };
  }, []);

  return (
    <section className="hero">
      <Navbar type="secondary" />
      <div className="container" style={{ position: 'relative' }}>
        <Heading>
          <Eyebrow>NYC’s trusted home cleaning</Eyebrow>
          <Headline color="grey.900">
            {/* Don't stress. <br />
            We'll handle the mess. */}
            Take a break, {width > 600 ? <br /> : null} let us clean.
          </Headline>
        </Heading>
        <Text
          zIndex={1}
          className="description"
          fontSize={'md'}
          w={['100%', '100%', '50%']}
        >
          {/* Select the size of your home, see your price and schedule your home
          cleaning for as early as tomorrow. */}
          {/* We disinfect all the frequently touched surfaces in your home! We use
          CDC recommended cleaning methods and detergents. */}
          Get an instant quote, find availability and schedule an appointment,
          all on our website.
        </Text>
        <Box mt={6}>
          <ZipQuote />
        </Box>
        {width > 800 ? (
          <Box position={'absolute'} top="-30%" w="45%" right="0%">
            <Image
              w="100%"
              src={require('../../assets/hero_blob.webp')}
              alt="A smiling customer relaxing at home"
            />
            <Badge>
              <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinejoin="round"
                  d="M12 3 5 6v5c0 4.4 3 8.3 7 9.6 4-1.3 7-5.2 7-9.6V6z"
                />
              </svg>
              Vetted local cleaners
            </Badge>
          </Box>
        ) : null}
        <br />
        <Box mt={[6, 0]}>
          <ImageGroup>
            <img src={require('../../assets/stars.svg').default} alt="Stars" />
            <span style={{ color: 'inherit' }}>Rated 5 stars on</span>
          </ImageGroup>
          <ImageGroup>
            <a
              href="https://goo.gl/maps/tP4bn6RjbRPgcBi99"
              target={'_blank'}
              rel="noopener noreferrer"
            >
              <Image
                h={'24px'}
                w={'72px'}
                src={require('../../assets/google.png')}
                alt="Google"
                loading="eager"
              />
            </a>
            <a
              href="https://www.trustpilot.com/review/heyhomero.com"
              target={'_blank'}
              rel="noopener noreferrer"
            >
              <img
                src={require('../../assets/trustpilot.svg').default}
                alt="Trustpilot"
                loading="eager"
                height={24}
              />
            </a>
            <a
              href="https://www.bark.com/en/us/company/homero/pk8q8/"
              target={'_blank'}
              rel="noopener noreferrer"
            >
              <Image
                loading="eager"
                src={require('../../assets/bark.png')}
                alt="Bark"
                h={'22px'}
                w={'73px'}
              />
            </a>
          </ImageGroup>
        </Box>
      </div>
    </section>
  );
}
